<template>
 <v-row class="pt-2" >
  <v-spacer/>
  <v-col cols="12" md="3">
    <v-autocomplete
      dense
      placeholder="เลือกมิเตอร์"
      solo
      multiple
      small-chips
      deletable-chips
      v-model="selectedMeter"
      :items="assets"
      item-text="assetName"
      item-value="assetId"
      return-object
    ></v-autocomplete>
  </v-col>
    <ENERGY_SUMMARY :meter="selectedMeter"/>
    <v-col cols="12">
    <ENERGY_DISTRIBUTION_BY_TIME :meter="selectedMeter" v-if="selectedMeter.length > 0"/>
      <v-skeleton-loader v-else
      class="mx-auto"
      type="card"
    ></v-skeleton-loader>
     </v-col>
    <ENERGY_COMPARE_BY_TIME :meter="selectedMeter"/>
   <v-col cols="12">
    <ENERGY_COMPARISON :meter="selectedMeter" v-if="selectedMeter.length > 0" />
    <v-skeleton-loader v-else
      class="mx-auto"
      type="card"
    ></v-skeleton-loader>
    </v-col>
     <v-col cols="12">
    <ENERGY_DISTRIBUTION_BY_LOAD />
    </v-col>
    </v-row>
</template>

<script>
import ENERGY_DISTRIBUTION from '@/components/energy_management/energy_distribution'
import ENERGY_DISTRIBUTION_BY_LOAD from '@/components/energy_management/energy_distribution_by_load'
import ENERGY_SUMMARY from '@/components/energy_management/energy_summary'
import ENERGY_COMPARISON from '@/components/energy_management/energy_comparison'
import ENERGY_DISTRIBUTION_BY_TIME from '@/components/energy_management/energy_distribution_by_time'
import ENERGY_COMPARE_BY_TIME from '@/components/energy_management/energy_compare_by_time'

export default {
    props: {
      update: {
        type: Boolean
      }
    },
    components: {
      ENERGY_DISTRIBUTION,
      ENERGY_DISTRIBUTION_BY_LOAD,
      ENERGY_SUMMARY,
      ENERGY_COMPARISON,
      ENERGY_DISTRIBUTION_BY_TIME,
      ENERGY_COMPARE_BY_TIME
    },
    computed: {
      assets() {
        return this.$store.state.Asset.assetEnergy.filter((el) => el.assetType === 'PowerMeter')
      },
      rootAssets() {
        return this.assets.filter((el) => el.root === true)
      },
      building: {
        get: function () {
          return this.$store.state.User.building
        },
        set: function (newValue) {
          this.$store.dispatch('User/SET_BUILDING', newValue)
        },
      },
    },
    watch: {
      building() {
        this.initMeters()
      },
      assets(val) {
        if (val.length && !this.selectedMeter.length) {
          this.initMeters()
        }
      },
    },
    mounted () {
      this.initMeters()
    },
    data() {
      return {
       selectedMeter: []
      }
    },
    methods: {
      initMeters() {
        this.selectedMeter = this.rootAssets.length ? [...this.rootAssets] : []
      },
    },
}

</script>
